import { isMobile } from "@digits-shared/helpers/devicesHelper"
import { useIsMobileLocation } from "src/frontend/components/Shared/Responsive/mobileRoutes"

export function useBlockMobile() {
  const isMobileLocation = useIsMobileLocation()
  return isMobile && !isMobileLocation
}
